<template>
    <svg :width="width" :height="height" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.4902 0.5C12.2141 0.5 11.9902 0.723858 11.9902 1V1.58117C10.8853 1.77814 10.0022 2.61599 9.73908 3.69658C8.91547 4.00545 8.15301 4.4483 7.47404 5H1C0.723858 5 0.5 5.22386 0.5 5.5V18V18.25C0.5 18.3002 0.507387 18.3486 0.521134 18.3943C0.7073 20.1218 2.10176 21.5 3.84211 21.5H16.1579C18.0288 21.5 19.5 19.9072 19.5 18C19.5 17.7239 19.2761 17.5 19 17.5H16.5V15.3012C18.2364 15.128 19.8332 14.8582 21.3476 14.5568L21.3472 14.5548C21.5768 14.5096 21.75 14.3071 21.75 14.0642V12.4253C21.75 12.2285 21.6346 12.0501 21.4551 11.9693L20.7564 11.655C20.6226 7.98541 18.3747 4.87195 15.242 3.69682C14.979 2.61592 14.0956 1.77786 12.9902 1.58106V1C12.9902 0.723858 12.7664 0.5 12.4902 0.5ZM15.5 15.3885C14.5474 15.46 13.5522 15.5006 12.506 15.5006C9.36575 15.5006 6.14556 15.0067 3.6728 14.5584L3.67315 14.5564C3.43925 14.5146 3.26172 14.3102 3.26172 14.0642V12.4253C3.26172 12.2285 3.37714 12.0501 3.5566 11.9693L4.22359 11.6693C4.29988 9.48677 5.12395 7.50019 6.43752 6H1.5L1.5 17.9997L1.5 18C1.5 19.4065 2.57372 20.5 3.84211 20.5C5.11049 20.5 6.18421 19.4065 6.18421 18C6.18421 17.7239 6.40807 17.5 6.68421 17.5H15.5V15.3885ZM12.9902 2.6061C13.759 2.8236 14.3223 3.53044 14.3223 4.36884V6.18904C14.3223 6.46518 14.5461 6.68904 14.8223 6.68904C15.0984 6.68904 15.3223 6.46518 15.3223 6.18904V4.81192C17.9193 5.99213 19.7627 8.75536 19.7627 12.0018C19.7627 12.2531 19.948 12.4611 20.1894 12.4965L20.75 12.7487V13.6549C18.2937 14.1291 15.632 14.5006 12.506 14.5006C9.62522 14.5006 6.65439 14.0713 4.26172 13.648V12.7487L4.84924 12.4844C4.92592 12.4635 4.99527 12.4249 5.0526 12.3732C5.1989 12.252 5.26509 12.0554 5.21883 11.8686C5.26848 8.67966 7.09705 5.97555 9.6588 4.81166V6.18904C9.6588 6.46518 9.88265 6.68904 10.1588 6.68904C10.4349 6.68904 10.6588 6.46518 10.6588 6.18904V4.36884C10.6588 3.53066 11.2218 2.82396 11.9902 2.60627V6.60511C11.9902 6.88125 12.2141 7.10511 12.4902 7.10511C12.7664 7.10511 12.9902 6.88125 12.9902 6.60511V2.6061ZM17.7383 12.1074C17.7383 11.8313 17.5144 11.6074 17.2383 11.6074H7.62166C7.34552 11.6074 7.12166 11.8313 7.12166 12.1074C7.12166 12.3836 7.34552 12.6074 7.62166 12.6074H17.2383C17.5144 12.6074 17.7383 12.3836 17.7383 12.1074ZM6.18139 20.5H16.1579C17.2713 20.5 18.2348 19.6574 18.4535 18.5H7.15012C7.0438 19.2739 6.69436 19.9722 6.18139 20.5Z"
            fill="url(#paint0_linear)"
        />
        <defs>
            <linearGradient
                id="paint0_linear"
                x1="0.5"
                y1="21.603"
                x2="21.7504"
                y2="21.603"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#672583" />
                <stop offset="0.505208" stop-color="#006B96" />
                <stop offset="1" stop-color="#00A1AE" />
            </linearGradient>
        </defs>
    </svg>
</template>

<script>
export default {
    name: 'HelmetGradient',
    props: {
        color: {
            type: String,
            default: '#373836',
        },
        width: {
            type: [Number, String],
            default: 22,
        },
        height: {
            type: [Number, String],
            default: 22,
        },
    },
};
</script>

<style></style>
